package com.cybersoftsolution.cybersoftsolutionweb.components.buttons

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.cards.MyOrientation
import com.cybersoftsolution.cybersoftsolutionweb.components.items.MenuItem
import com.cybersoftsolution.cybersoftsolutionweb.components.items.SectionItem
import com.cybersoftsolution.cybersoftsolutionweb.models.MyElement
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.role
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

data class MenuElement(
    override var text: String,
    override var id: String?,
    var icon: Resources.FaIconsClassName? = null,
    override var visible: Boolean = true
):MyElement()

val profileMenu = listOf(
    MenuElement(
        text = "Personalizar perfil",
        id = "editProfileMenuId",
        icon = Resources.FaIconsClassName.EditProfile_ICO
    ),
    MenuElement(
        text = "Cambiar contraseña",
        id = "changePasswordMenuId",
        icon = Resources.FaIconsClassName.Password_ICO
    ),
)

@Composable
fun GroupButtons(
    elements : List<MenuElement>,
    position: MyOrientation = MyOrientation.vertical,
    id: String,
    onMenuClick: (String) -> Unit
) {
    Div(
        attrs = Modifier
            .id(id)
//            .fillMaxWidth(90.percent)
            .classNames(if (position == MyOrientation.vertical) "btn-group-vertical" else "btn-group")
            .role("group")
            .toAttrs{
                attr("aria-label", "Vertical button group")
            }
    ) {
        elements.forEach { element ->
            Button(
                attrs = Modifier
//                    .classNames("btn", "btn-light")
                    .classNames("btn", "btn-secondary")
//                    .classNames("btn", "btn-primary")
                    .toAttrs()

            ) {
                MenuItem(
                    modifier = Modifier
                        .fillMaxWidth(),
                    id = element.id.orEmpty(),
//                            visible = section.visible,
                    selected = false,
                    title = element.text,
                    icon = element.icon,
                    onClick = {
                        onMenuClick(element.id.orEmpty())
                    },
                )
//                Text(element.text)
            }
        }



    }

}

/*
<div class="btn-group-vertical" role="group" aria-label="Vertical button group">
  <button type="button" class="btn btn-primary">Button</button>
  <button type="button" class="btn btn-primary">Button</button>
  <div class="btn-group" role="group">
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
      Dropdown
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Dropdown link</a></li>
      <li><a class="dropdown-item" href="#">Dropdown link</a></li>
    </ul>
  </div>
  <div class="btn-group dropstart" role="group">
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
      Dropdown
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Dropdown link</a></li>
      <li><a class="dropdown-item" href="#">Dropdown link</a></li>
    </ul>
  </div>
  <div class="btn-group dropend" role="group">
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
      Dropdown
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Dropdown link</a></li>
      <li><a class="dropdown-item" href="#">Dropdown link</a></li>
    </ul>
  </div>
  <div class="btn-group dropup" role="group">
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
      Dropdown
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Dropdown link</a></li>
      <li><a class="dropdown-item" href="#">Dropdown link</a></li>
    </ul>
  </div>
</div>
 */